// lazyPage.js — a route page in its own JavaScript chunk, so a visitor only
// downloads the page they're on (plus the shared app shell).
//
// preload() fetches the chunk. index.js preloads the first page before the
// app renders, so a pre-rendered page draws at once instead of flashing a
// loading state; links preload their page on hover, focus or touch. A page
// that isn't loaded yet suspends while its chunk arrives. Each mount keeps
// whichever component it started with, so a page never remounts (and loses
// its state) when the chunk lands.

import React, { useState } from "react";

export function lazyPage(load) {
  let Loaded = null;
  let pending = null;
  const preload = () => {
    pending = pending || load().then((m) => {
      Loaded = m.default;
      return m;
    });
    return pending;
  };
  const Lazy = React.lazy(preload);
  function Page(props) {
    const [Component] = useState(() => Loaded || Lazy);
    return <Component {...props} />;
  }
  Page.preload = preload;
  return Page;
}
